import { getFiles } from './getFiles'
import { setUploadedFiles } from './setUploadedFiles'

/**
 * @package     Image Hopper
 * @copyright   Copyright (c) 2021, Image Hopper
 * @license     http://opensource.org/licenses/gpl-2.0.php GNU Public License
 */

export function addFile (formId, fieldId, fileInfo) {
  const files = getFiles(fieldId, formId)
  files.push(fileInfo)

  setUploadedFiles(fieldId, files, formId)
}

/**
 * When an image is reordered before the upload is complete, it'll be added to our file list already and we should
 * update the object instead of appending to the end
 */
export function addOrUpdateFile (formId, fieldId, originalFile, fileInfo) {
  const files = getFiles(fieldId, formId)

  let found = false
  files.forEach((file, index) => {
    if (originalFile.name === file.uploaded_filename) {
      found = true
      files[index] = fileInfo
    }
  })

  if (!found) {
    files.push(fileInfo)
  }

  setUploadedFiles(fieldId, files, formId)
}
